/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type IRListIRRequest = {
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: IRListIRRequest.direction | null;
};

export namespace IRListIRRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
